import React from 'react';
import SupporterInformation from './supporter-information';

const MainSectionRight = () => (
  <div className='sticky top-[80px] flex h-fit w-[320px] flex-col space-y-[24px] lg:w-[380px]'>
    <SupporterInformation />
  </div>
);

export default MainSectionRight;
